const FromArr = [{
		title: "产品线：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 192,
		height: 32,
		disabled: false,
		marginLeft: 40,
		marginTop: 35,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: []
	}, {
		title: "业务员：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 182,
		height: 32,
		disabled: false,
		marginLeft: 40,
		marginTop: 28,
		displayVal: "inline-block",
		fontWeightVal: 500
	}, {
		title: "年月：",
		inputtype: "month",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 192,
		height: 32,
		disabled: false,
		marginLeft: 60,
		marginTop: 35,
		displayVal: "inline-block",
		fontWeightVal: 500
	},
	{
		title: "起始时间：",
		StartTime: '',
		EndTime: '',
		inputtype: "dateSection",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "date",
		placeholder: "请选择",
		widthLeft: 213,
		widthRight: 213,
		heightLeft: 32,
		heightRight: 32,
		disabled: false,
		marginLeft: 26,
		marginTop: 35,
		displayVal: "inline-block",
		fontWeightVal: 500
	}, {
		title: "医院：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 182,
		height: 32,
		disabled: false,
		marginLeft: 87,
		marginTop: 28,
		displayVal: "inline-block",
		fontWeightVal: 500
	}, {
		title: "状态：",
		inputtype: "select",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "",
		placeholder: "请选择",
		width: 192,
		height: 32,
		disabled: false,
		marginLeft: 55,
		marginTop: 30,
		displayVal: "inline-block",
		fontWeightVal: 500,
		options: []
	}, {
		modelvalue: '',
		title: "单据号：",
		inputtype: "input",
		inputflag: true,
		fontSize: 14,
		color: "#333333",
		lableheight: 20,
		X: false,
		types: "text",
		placeholder: "请输入",
		width: 180,
		height: 32,
		disabled: false,
		marginLeft: 45,
		marginTop: 23,
		displayVal: "inline-block",
		fontWeightVal: 500
	}
]
export default FromArr;